import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Menu,
  Popover,
  ScrollArea,
  Space,
  Table,
  Text,
} from "@mantine/core";
import useStyles from "./style";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { IconEdit, IconEye } from "@tabler/icons-react";
import { GoDotFill } from "react-icons/go";
import CustomInvoicePagination from "../Pagination/CustomInovicePagination";
import moment from "moment";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import { useState } from "react";
import RecordNotFound from "../RecordNotFound";
import { updateSkypointProspect } from "../../services/skypointProspect";
import { useNavigate } from "react-router-dom";

const PipelinesTable = ({
  currentPage,
  setCurrentPage,
  onEditClick,
  onViewClick,
  onDeleteClick,
  callGetProspectWithFiltersCount,
}) => {
  const { classes, cx } = useStyles();
  const {
    skypointProspects,
    skypointProspectsTotalCount,
    skypointProspectsCount,
    skypointProspectsLoading,
    skypointProspectsStatus,
  } = useSelector((state) => state?.skypointProspects);
  const navigate = useNavigate();

  const getClassname = (status) => {
    switch (status) {
      case "New":
        return classes.greenStatus;
      case "Contacted":
        return classes.orangeStatus;
      case "Demo Scheduled":
        return classes.blueStatus;
      case "Closed":
        return classes.purpleStatus;
    }
  };

  const handleUpdateProspectStatus = async (prospectItem, status) => {
    try {
      const payload = {
        ProspectStatus: status?.id,
        id: prospectItem?._id,
      };
      const res = await updateSkypointProspect(
        payload,
        callGetProspectWithFiltersCount
      );
      if (status?.ProspectStatus === "Closed" && res) {
        navigate(`/home/provider-skypoint/prospect-add`, {
          state: {
            data: prospectItem,
          },
        });
      }
    } catch (error) {}
  };

  return (
    <>
      <Box className={classes.tableContainer}>
        <ScrollArea sx={{ minHeight: "300px" }} w="100%">
          <Table highlightOnHover={false} className={classes.table}>
            <thead>
              <tr>
                <th>Status</th>
                <th>Provider Name</th>
                <th>Contact Name</th>

                <th>Contact info</th>

                <th>State</th>

                <th>Created Date</th>

                <th>Last Contact Date</th>

                <th>Amount</th>

                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {skypointProspectsLoading ? (
                <tr>
                  <td colSpan={1000}>
                    <TableLoader />
                  </td>
                </tr>
              ) : skypointProspectsTotalCount > 0 &&
                skypointProspectsCount === 0 &&
                skypointProspects?.length === 0 ? (
                <tr>
                  <td colSpan={1000}>
                    <Box className={classes.notFoundTextContainer}>
                      <RecordNotFound />
                      <Text className={classes.notFoundText}>
                        You don&apos;t have any record, click on “New Prospect"
                      </Text>
                    </Box>
                  </td>
                </tr>
              ) : (
                skypointProspects?.length > 0 &&
                skypointProspects?.map((item, index) => {
                  const isClosedStatus =
                    item?.ProspectStatus?.ProspectStatus === "Closed";
                  return (
                    <tr key={item?._id}>
                      <td>
                        <Menu
                          disabled={isClosedStatus}
                          withinPortal
                          position="bottom-start"
                          classNames={{
                            dropdown: classes.menuDropdown,
                            item: classes.menuDropdownItem,
                          }}
                        >
                          <Menu.Target>
                            <Badge
                              leftSection={<GoDotFill />}
                              className={cx(
                                classes.status,
                                getClassname(
                                  item?.ProspectStatus?.ProspectStatus
                                )
                              )}
                              sx={{
                                cursor: isClosedStatus ? "default" : "pointer",
                              }}
                            >
                              {item?.ProspectStatus?.ProspectStatus}
                            </Badge>
                          </Menu.Target>
                          <Menu.Dropdown>
                            {skypointProspectsStatus
                              ?.filter(
                                ({ id }) => id !== item?.ProspectStatus?._id
                              )
                              ?.map((status) => (
                                <Menu.Item
                                  onClick={() =>
                                    handleUpdateProspectStatus(item, status)
                                  }
                                >
                                  {status?.ProspectStatus}
                                </Menu.Item>
                              ))}
                          </Menu.Dropdown>
                        </Menu>
                      </td>

                      <td className={classes.providerInfoTd}>
                        <p>
                          {item?.firstName} {item?.lastName}
                        </p>
                        <p>ID: {item?._id?.slice(0, 7)}</p>
                      </td>

                      <td>
                        {`${item?.contactFirstName} ${item?.contactLastName}` ||
                          "-"}
                      </td>

                      <td className={classes.providerInfoTd}>
                        <p>{item?.phone || "-"}</p>
                        <p>{item?.email || "-"}</p>
                      </td>

                      <td>{item?.state || "-"}</td>
                      <td>
                        {item?.createdAt
                          ? moment(item?.createdAt).format("DD/MM/YYYY")
                          : "-"}
                      </td>
                      <td>
                        {item?.date
                          ? moment(item.date).format("DD/MM/YYYY")
                          : "-"}
                      </td>

                      <td>
                        {item?.amount ? "$" : ""}
                        {item?.amount || "0"}
                      </td>

                      <td>
                        <Menu shadow="md" position="left" zIndex={1000}>
                          <Menu.Target>
                            <ActionIcon>
                              <BiDotsVerticalRounded
                                size={20}
                                color="#737373"
                              />
                            </ActionIcon>
                          </Menu.Target>
                          <Menu.Dropdown>
                            <Menu.Item
                              icon={<IconEye size={14} />}
                              onClick={() => onViewClick(item)}
                            >
                              View
                            </Menu.Item>

                            <Menu.Item
                              icon={<IconEdit size={14} />}
                              onClick={() => onEditClick(item)}
                            >
                              Edit
                            </Menu.Item>
                            <Menu.Item
                              icon={<IconEdit size={14} />}
                              onClick={() => onDeleteClick(item)}
                            >
                              Delete
                            </Menu.Item>
                          </Menu.Dropdown>
                        </Menu>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </ScrollArea>
        <Space h={70}></Space>
      </Box>
      {skypointProspectsCount > 10 && (
        <CustomInvoicePagination
          data={skypointProspectsCount}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={(page) => setCurrentPage(page)}
        />
      )}
    </>
  );
};

export default PipelinesTable;
